import { SET_VEHICLE_INFO } from '../actions/types';

// TODO: change to use ES6 arrow functions 
export default function vehicleInfo(state = {}, action = null) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_VEHICLE_INFO:
				return action.payload;
			default:
				return state; 
		}
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/vehicleInfo.js